<ng-container *transloco="let t; read: 'employee'">
  <ng-container *ngIf="vm$ | async as vm">
    <h2>{{ t("worktime") }}</h2>
    <kendo-grid
      [data]="vm.workTimes"
      (add)="addHandler($event)"
    >
      <ng-template kendoGridToolbarTemplate>
        <button 
          kendoGridAddCommand
          [disabled]="hasOpenWorkTime(vm.workTimes)">{{ t("addWorkTime") }}</button>
      </ng-template>

      <kendo-grid-column
        media="(min-width: 450px)"
        field="validFrom"
        [title]="t('validFrom')"
        [width]="150"
      >
        <ng-template kendoGridCellTemplate let-dataItem>
          {{ dataItem.validFrom | date : "dd.MM.yyyy"}}
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column
        media="(min-width: 450px)"
        field="validTo"
        [title]="t('validTo')"
        [width]="150"
      >
        <ng-template kendoGridCellTemplate let-dataItem>
          {{ dataItem.validTo | date : "dd.MM.yyyy" }}
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column
        media="(min-width: 450px)"
        field="hasFlexTime"
        [title]="t('hasFlexTime')"
        [width]="150"
        editor="boolean"
      >
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem.hasFlexTime ? t('true') : t('false') }}
      </ng-template>
      </kendo-grid-column>

      <kendo-grid-column
        media="(min-width: 450px)"
        field="vacationDays"
        [title]="t('vacationDays')"
        [width]="150"
        editor="number"
      >
        <ng-template kendoGridCellTemplate let-dataItem>
          {{ vacationDaysForWorkload(dataItem) | number : "1.0-1" }}
        </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      media="(min-width: 450px)"
      field="workload"
      [title]="t('workload')"
      [width]="150"
      editor="number"
    >
    </kendo-grid-column>

    <kendo-grid-column
      media="(min-width: 450px)"
      field="workHourAmountWeek"
      [title]="t('workHourAmountWeek')"
      [width]="150"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ (dataItem.workHourAmountWeek | stringToTimeObject)?.hours + ":" + ((dataItem.workHourAmountWeek | stringToTimeObject)?.minutes | number:'2.0') }}
      </ng-template>
    </kendo-grid-column>

    <ng-template kendoGridDetailTemplate let-dataItem let-rowIndex="rowIndex">
      <app-work-time-form
        [workTime]="dataItem"
        [tenantSettings]="tenantSettings"
        [employee]="vm.employee"
        [isFirstWorkTime]="rowIndex == 0"
      ></app-work-time-form>
    </ng-template>

    <ng-template kendoGridNoRecordsTemplate>
      {{ t("workTime.noResults") }}
    </ng-template>
  </kendo-grid>

  <kendo-dialog
    *ngIf="active"
    (close)="oncloseDialog()"
  >
    <kendo-dialog-titlebar>
      {{ t("addNewWorkTime") }}
    </kendo-dialog-titlebar>

    <app-work-time-form
        [tenantSettings]="tenantSettings"
        [employee]="vm.employee"
        [isFirstWorkTime]="vm.workTimes.length == 0"
    ></app-work-time-form>

  </kendo-dialog>
  <ng-container>
</ng-container>
